import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo-2.svg';
import logo1 from '../../assets/images/logoBlack.svg';
import jwt from 'jsonwebtoken';

import { Wrapper } from './style';
import { useState, useEffect, useContext } from 'react';

import { isEmpty } from 'lodash';
import { AlertWrapper } from '../UI/styledConstants';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import { getUserPermission, getUserProfileRequest, getUserWalletRequest } from '../../utils/api';
import caretDown from '../../assets/images/caret-down.svg';
import aeps from '../../assets/images/aeps-balance.svg';
import main from '../../assets/images/main-balance.svg';
import TravelAutoLogin from '../../TravelAutoLogin';

function Component({ handleModal = () => {}, cls }) {
	const [message, setMessage] = useState({});
	const [toggle, setToggle] = useState(false);
	const [balance, setBalance] = useState({});

	const navigate = useNavigate();

	const { pathname } = useLocation();
	useEffect(() => {
		setToggle(false);
	}, [pathname]);

	const { userDetails, setUserDetails, setApiPermission, apiPermission, refresh, setAlert } = useContext(GlobleContaxt);

	useEffect(() => {
		if (localStorage.getItem('ID Token')) {
			const user_role = localStorage.getItem('UserRole');
			getUserProfileRequest().then((resp) => {
				if (resp?.success) {
					setUserDetails(resp?.data);
				} else {
				}
			});

			getUserPermission().then((resp) => {
				console.log("resprespresp",resp)


				if (resp?.success) {
									const allServiceSkus = (resp?.data || [])
  .flatMap(section => section?.serviceList || [])
  .filter(service => service?.serviceSku) 
  .map(service => service?.serviceSku);

  if(isEmpty(allServiceSkus)){
setApiPermission(["OTHERS"])
  }else{
	setApiPermission([...allServiceSkus,'OTHERS'])
  }

				}
			});
		}
	}, [localStorage.getItem('ID Token')]);

	const getWalletBalance = () => {
		getUserWalletRequest('').then((resp) => {
			if (resp?.success) {
				setBalance(resp?.data);
			}
		});
	};

	useEffect(() => {
		if(localStorage.getItem('ID Token')){
				getWalletBalance();
		}
	
	}, [localStorage.getItem('ID Token'), refresh]);


	const logOut = (key) => {
		sendMessageToIframe('logOut');
		localStorage.removeItem('ID Token');
		localStorage.removeItem('UserRole');
		setUserDetails({});
		if (key === 'logout') {
			setAlert({ type: 'success', msg: 'User logout successfully' });
		}
		if (key === 'exp') {
			setAlert({ type: 'error', msg: 'Your Session Expired Please Login Again To Continue' });
		}

		setUserDetails({});
		navigate('/', { replace: true });
	};

	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	const spinner = () => {
		setToggle(!toggle);
	};

	const sendMessageToIframe = (key = 'login') => {
		const iframe = document.getElementById('myIframe');

		if (key === 'login') {
			///iframe.contentWindow.postMessage({token:localStorage.getItem('ID Token')}, 'https://tripscroll.com');

			var link = document.createElement('a');
			link.href = 'https://tripscroll.com';
			link.target = '_blank';
			link.click();
		} else {
			iframe.contentWindow.postMessage({ logout: true }, 'https://tripscroll.com');
		}
	};

	useEffect(() => {
    const handleLogout_ = () => {
       logOut("exp")

    };

    window.addEventListener("force-logout", handleLogout_);

    return () => {
      window.removeEventListener("force-logout", handleLogout_);
    };
  }, []);

	return (
		<Wrapper className={` ${cls}`}>
			<div className="container">
				{Object.keys(userDetails) == 0 ? (
					''
				) : (
					<div className="header-balance flex justify-between">
						{Object.keys(userDetails) == 0 ? (
							<div></div>
						) : (
							<div className="balance flex">
								{apiPermission?.includes("AEPS_WALLET") && (
									<div className="aeps-balance flex">
										<div className="img">
											<img src={aeps} alt="aeps-img" />
										</div>
										<div className="desc">
											<p className="heading">AEPS Balance </p>
											<p className="value">₹ {balance?.AEPS_WALLET?.toFixed(2)}</p>
										</div>
									</div>
								)}
								<div className="main-balance flex">
									<div className="img">
										<img src={main} alt="main-wallet-img" />
									</div>
									<div className="desc">
										<p className="heading">Main Balance </p>
										<p className="value">₹ {balance?.MAIN_WALLET?.toFixed(2)}</p>
									</div>
								</div>
							</div>
						)}
						{Object.keys(userDetails) == 0 ? (
							<div className="header-buttons">
								<button className="login button-outline" onClick={() => handleModal(true)}>
									Login
								</button>
							</div>
						) : (
							<div className="header-buttons">
								<div className="name ">
									<div className="profile">
										<div className="logoName">
											{/* <img src={userIcon} alt="userIcon" style={{ display: 'inline-block',width:"40px",height:"40px" }} /> */}
											<span> {`${userDetails.firstName.charAt(0) + userDetails.lastName.charAt(0)}`}</span>
										</div>
										{userDetails.firstName} <img src={caretDown} alt="caretDown" style={{ display: 'inline-block' }} />
										<div className="profile-dropdown">
											<ul>
												<li>
													<span onClick={() => logOut('logout')}>Logout</span>
												</li>
												<li>
													<Link to="/user-profile">User Profile</Link>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				)}

				<div className="top-header">
					<div className="logo">
						<Link to="/">
							<img className="logo1" src={logo1}></img>
							<img className="logo2" src={logo}></img>
						</Link>
					</div>

					<div className={`header-link ${toggle ? 'active' : ''}`}>
						<ul>
							<li>
								<NavLink to="/">Home</NavLink>
							</li>

							<li>
								<NavLink to="/dashboard">Services</NavLink>
							</li>
							{(apiPermission?.includes("BBPS") || isEmpty(userDetails?.userName)) && <li>
								<NavLink to="/services">BBPS</NavLink>
							</li>}
							<li>
								<a href="https://tripscroll.com" target="_blank">
									Travel
								</a>
							</li>

							
							<li>
								<NavLink to="/consumer">Consumer</NavLink>
							</li>

							<li>
								<NavLink to="/company">Company</NavLink>
							</li>
							
							

							{userDetails?.firstName && (<li className="dropdown_li">
								<div className="nav-more center" style={{ gap: '10px' }}>
									More <img src={caretDown} alt="caretDown" style={{ display: 'inline-block' }} />
									<div className="profile-dropdown">
										<ul>
										
										
										
												<>
													<li>
														<NavLink className="d-m-block" to="/transaction-history">
															Transaction History
														</NavLink>
													</li>
													<li>
														<NavLink  to="/wallet-history">Pay2Mobile Wallet</NavLink>
													</li>
													<li>
														<NavLink to="/complaint-history">Complain History</NavLink>
													</li>
													<li>
														<NavLink to="/bbps-transaction-history">BBPS Transaction History</NavLink>
													</li>
													<li>
														<NavLink to="/collect-transaction">Collect Transaction</NavLink>
													</li>
												</>
										
										</ul>
									</div>
								</div>
							</li>)}

							{userDetails?.firstName && (
								<>
									<li className="d-m-block">
										<NavLink to="/user-profile">User Profile</NavLink>
									</li>

									<li className="d-m-block">
										<NavLink to="/wallet-history">Pay2Mobile Wallet</NavLink>
									</li>
									<li>
										<NavLink className="d-m-block" to="/transaction-history">
											Transaction History
										</NavLink>
									</li>
								
													<li>
														<NavLink className="d-m-block" to="/complaint-history">Complain History</NavLink>
													</li>
													<li>
														<NavLink className="d-m-block" to="/bbps-transaction-history">BBPS Transaction History</NavLink>
													</li>
													<li>
														<NavLink className="d-m-block" to="/collect-transaction">Collect Transaction</NavLink>
													</li>
								</>
							)}
						</ul>
					</div>
					<div className="header-buttons">
						{Object.keys(userDetails) == 0 ? (
							<>
								<button className="login button-outline" onClick={() => handleModal(true)}>
									Login
								</button>
							</>
						) : (
							<>
								<div className="balance flex d-s-none">
									{apiPermission?.includes("AEPS_WALLET") && (
										<div className="main-balance flex">
											<div className="img">
												<img src={aeps} alt="aeps-img" />
											</div>
											<div className="desc">
												<p className="heading">AEPS Balance </p>
												<p className="value">₹ {balance?.AEPS_WALLET?.toFixed(2)}</p>
											</div>
										</div>
									)}
									<div className="main-balance flex">
										<div className="img">
											<img src={main} alt="main-wallet-img" />
										</div>
										<div className="desc">
											<p className="heading">Main Balance </p>
											<p className="value">₹ {balance?.MAIN_WALLET?.toFixed(2)}</p>
										</div>
									</div>
								</div>
								<div className="name d-s-none">
									<div className="profile">
										<div className="logoName">
											{/* <img src={userIcon} alt="userIcon" style={{ display: 'inline-block',width:"40px",height:"40px" }} /> */}
											<span className="profile-text"> {`${userDetails.firstName.charAt(0) + userDetails.lastName.charAt(0)}`}</span>
										</div>
										{userDetails.firstName} <img src={caretDown} alt="caretDown" style={{ display: 'inline-block' }} />
										<div className="profile-dropdown">
											<ul>
												<li>
													<span onClick={() => logOut('logout')}>Logout</span>
												</li>
												<li>
													<Link to="/user-profile">User Profile</Link>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</>
						)}
						<div className={`toggle-icon ${toggle ? 'active' : ''}`} onClick={spinner}>
							<div className="spinner"></div>
							<div className="spinner"></div>
						</div>
					</div>
				</div>
				<TravelAutoLogin logOut={logOut} />
			</div>
		</Wrapper>
	);
}

export default Component;
